import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class SendDocsUserCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(user_id, receiver_user_id, num_docs, contract_origin_id): Promise<{ [key: string]: string; }> {
    let args = {user_id:user_id, receiver_user_id:receiver_user_id, num_docs:num_docs, contract_origin_id:contract_origin_id};
    return this.dispatcher.dispatch('send.docs.user', args)
  }
}
